var cdButtonArr;
var cdTabArr;
var cdNameArr = ["Student's Book","Activity Book"];
var cdIndex = 0;
var cdName = "cd1";
var track = 0;
var trackUrl = "";
var song;

jQuery(document).ready(function() {
	var tracker = $('.tracker');

	cdButtonArr = new Array($('#CD1'),$('#CD2'));
	cdTabArr = new Array($('#tab1'),$('#tab2'));

	for (var k = 0; k < cdButtonArr.length; k++){
		cdButtonArr[k].click(function(){
			changeCD(this);
		});
	}

	begin();
	changeCD(cdButtonArr[0]);


	function changeCD(e){
				$('.playlist li').removeClass('active');
				var obj = $(e);
				var cd = obj.attr('cd');
				cdName = cd;
				for (var k = 0; k < cdTabArr.length; k++){
					var obj_ =  $(cdTabArr[k]);
					var cd_ = obj_.attr('cd');
					if(cd != cd_){
						obj_.addClass("v-hide");
						$(cdButtonArr[k]).removeClass("v-actived");
					}else{
						cdIndex = k;
						$(cdButtonArr[k]).addClass("v-actived");
						obj_.removeClass("v-hide");
					}
				}
				//------------
				$('#ico-cd').attr("src" , "/img/frontend/images/" + cd +".png");
				var str = cdNameArr[cdIndex];
				$('#cd-title').html(str);
				if(track != 0){
					song.pause();
					$('.play').removeClass('hidden');
					$('.pause').removeClass('visible');
				}

				var cdID = $(cdTabArr[cdIndex]).attr("id");
				//alert($('#' + cdID + ' .playlist li:first-child').attr('audiourl'));
				rotationCD(false);
				track = 0;
				sBegin = true;
				initAudio($('#' + cdID + ' .playlist li:first-child'));
	}

	function rotationCD(val){
			if(val){
				$('#ico-cd').removeClass("no-rotate");
				$('#ico-cd').addClass("rotate");
			}else{
				$('#ico-cd').addClass("no-rotate");
				$('#ico-cd').removeClass("rotate");
			}
		}
		function playSound(){
			rotationCD(true);
		}
		function stopSound(){
			rotationCD(false);
		}

		function begin(){
			var tracks = 0;
			for (var k = 0; k < cdTabArr.length; k++){
				var obj = $(cdTabArr[k]);
				var cd = obj.attr('cd');
				var ul = obj.children("ul");
				tracks = obj.attr("tracks");
				ul.empty();

				for (var j = 1; j <= tracks; j++){
					ul.append('<li audiourl="/storage/audio_cd/mp3/' +cd+ '/Track ' + j +'.mp3" track = "'+ j +'">Track ' + j + '</li>');
				}
			}
		}



	function getTimeLabel(num){
		var  m  = parseInt(num/60);
		var   s =  parseInt(num % 60);
		if(m < 10)
			m = "0" + m;
		if(s < 10)
			s = "0" + s;
		var str = m + ":" + s;
		return str;
	}



    // inner variables

    var tracker = $('.tracker');
    var volume = $('.volume');
	var sBegin = true;

    function initAudio(elem) {
        var url = elem.attr('audiourl');
        var str = cdNameArr[cdIndex];
		track = elem.attr('track');
		//alert(track);
		var cdID = $(cdTabArr[cdIndex]).attr("id");

		//alert("track" + track);

		if(song){
			stopAudio();
		}

        song = new Audio(url);

        // timeupdate event listener
        song.addEventListener('timeupdate',function (){
            var curtime = parseInt(song.currentTime, 10);
            tracker.slider('value', curtime);
			$('#lb-current').html(getTimeLabel(curtime));
        });

        $('.playlist li').removeClass('active');
        elem.addClass('active');


		$('#cd-title').html(str);

		$('#lb-time').empty();
		$('#lb-current').empty();
		//playAudio();


		song.addEventListener('ended', function() {
			stopAudio();
		}, false);

		song.addEventListener("canplay",function(){
			var curtime = parseInt(song.currentTime, 10);
			$('#lb-current').html(getTimeLabel(curtime));
			$('#lb-time').html(getTimeLabel(song.duration));
			if(!sBegin){
				playAudio();
			}
			sBegin = false;
			var str = cdNameArr[cdIndex];
			$('#cd-title').html(str + " - " + " Track" + track);
		});


	}

    function playAudio() {
        song.play();
		$('#lb-time').html(getTimeLabel(song.duration));
        tracker.slider("option", "max", song.duration);
        $('.play').addClass('hidden');
        $('.pause').addClass('visible');
		rotationCD(true);
    }
    function stopAudio() {
        song.pause();
        $('.play').removeClass('hidden');
        $('.pause').removeClass('visible');
		rotationCD(false);
    }

    // play click
    $('.play').click(function (e) {
        e.preventDefault();

        playAudio();
    });

    // pause click
    $('.pause').click(function (e) {
        e.preventDefault();

        stopAudio();
    });

    // forward click
    $('.fwd').click(function (e) {
        e.preventDefault();

        stopAudio();

		var cdID = $(cdTabArr[cdIndex]).attr("id");
		//alert(cdID);
        var next = $('#' + cdID + ' .playlist li.active').next();
        if (next.length == 0) {
            next = $('#' + cdID + ' .playlist li:first-child');
        }
        initAudio(next);
    });

    // rewind click
    $('.rew').click(function (e) {
        e.preventDefault();

        stopAudio();
		var cdID = $(cdTabArr[cdIndex]).attr("id");

        var prev = $('#' + cdID + ' .playlist li.active').prev();

        if (prev.length == 0) {
            prev = $('#' + cdID +'.playlist li:last-child');
        }
        initAudio(prev);
    });


    // playlist elements - click
    $('.playlist li').click(function () {
        stopAudio();
        initAudio($(this));
    });

    // initialization - first element in playlist

    // initialize the volume slider
    volume.slider({
        range: 'min',
        min: 1,
        max: 100,
        value: 80,
        start: function(event,ui) {},
        slide: function(event, ui) {
            song.volume = ui.value / 100;
        },
        stop: function(event,ui) {},
    });

    // empty tracker slider
    tracker.slider({
        range: 'min',
        min: 0, max: 10,
        start: function(event,ui) {},
        slide: function(event, ui) {
            song.currentTime = ui.value;
        },
        stop: function(event,ui) {}
    });
});

